exports.api_url = "http://weblio-api.julienpoirier-webdev.com/"
